import { Suspense, lazy } from 'react';
import type { CodeEditorProps } from './types';
import { DEFAULT_HEIGHT, THEME_BACKGROUNDS } from './constants';

const LazyCodeEditor = lazy(() => import('./code-editor-impl'));

/**
 * Lazy-loaded Monaco code editor.
 *
 * Monaco (~1 MB gzipped) is split into its own chunk and only downloaded when
 * this component first renders. The fallback is a plain background box that
 * matches the editor theme so the transition is seamless — no spinner flash.
 */
export function CodeEditor(props: CodeEditorProps) {
  const height = props.height ?? DEFAULT_HEIGHT;
  const background = THEME_BACKGROUNDS[props.theme ?? 'dark'];

  return (
    <Suspense fallback={<div style={{ height, width: '100%', background }} />}>
      <LazyCodeEditor {...props} />
    </Suspense>
  );
}
